import React, { KeyboardEvent, MouseEvent } from 'react';
import { useHistory } from 'react-router';
import cx from 'classnames';

import { sanitiseLinks, wordpressImgToImgixURL } from 'Utilities';

import styles from './Page.scss';

type PageProps = {
  className?: string;
  content: string;
  title: string;
  wordpressContent: {
    className?: string;
  };
};

export const Page = ({
  className,
  content,
  title,
  wordpressContent,
}: PageProps) => {
  const history = useHistory();

  const linkClick = (e: MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    const url = target.getAttribute('href')
      || target.parentElement?.getAttribute('href');

    if (
      url
      && url.charAt(0) === '/'
      && !(e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey)
    ) {
      e.preventDefault();
      history.push(url);
    }

    if (url && /^#privacy-section/.test(url)) {
      e.preventDefault();
      target.classList.add('wp-privacy-link-hidden');
      document.getElementById(url.replace('#', ''))?.classList.add('active');
    }
  };

  const keyPress = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key.toLowerCase() === 'enter') {
      // Convert KeyboardEvent to MouseEvent-compatible object
      linkClick(e as unknown as MouseEvent<HTMLElement>);
    }
  };

  return (
    <div
      className={cx(styles.component, className)}
      onClick={linkClick}
      onKeyDown={keyPress}
      {...wordpressContent}
      role="link"
      tabIndex={0}
    >
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <div
        dangerouslySetInnerHTML={{
          __html: sanitiseLinks(wordpressImgToImgixURL(content)),
        }}
      />
    </div>
  );
};
